import { buildQuery, containsQuery, OdataFilters, queryCollection } from "helpers/reqparams";
import { alertRequest, body, request } from "services/request";

const routeTemplates = "api/RouteTemplates";
const routesQuery = {
    orderBy: "id desc",
};

const list = (params: {}) => request(`${routeTemplates}/getlist${containsQuery(params)}`, { method: "GET" });

const index = ({ preparedFilter, ...params }: OdataFilters) => {
    const query = queryCollection(params, { filter: { ...preparedFilter }, ...routesQuery });
    return request(`${routeTemplates}/getlist${query}`, { method: "GET" }, { countInHeaders: true });
};

const apply = (params: {}) => alertRequest(`${routeTemplates}/apply`, body(params));

const delItem = (params: {}) => alertRequest(`${routeTemplates}/delete`, body(params));

const getItem = ({ id }: { id: string }) => {
    const query = buildQuery({ filter: { id: parseInt(id) } });
    return request(`${routeTemplates}/getlist${query}`, { method: "GET" }).then(
        (data) => data && data.length > 0 && data[0],
    );
};

export { list, apply, delItem, index, getItem };
